module.exports = __webpack_public_path__ + "img/mobile-product-case-index-pharmaceutical.9b87a3b0.png";